import apiTrainings from '@/api/trainings'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createTrainingStart: '[create training] Create trainer start',
  createTrainingSuccess: '[create training] Create trainer success',
  createTrainingFailure: '[create training] Create trainer failure'
}

export const actionTypes = {
  createTraining: '[create training] Create training'
}

const mutations = {
  [mutationTypes.createTrainingStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createTrainingSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createTrainingFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createTraining](context, {training}) {
    context.commit(mutationTypes.createTrainingStart)
    return new Promise(resolve => {
      apiTrainings
        .createTraining(training)
        .then(response => {
          context.commit(mutationTypes.createTrainingSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createTrainingFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
